var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Toolbar'),_c('v-content',[_c('router-view')],1),[_vm._t("drawer")],void 0,_c('LoadingComponent'),_c('GenericMessageDialog'),(false)?_c('ConsentSnackbar'):_vm._e(),_c('GenericSnackbar')],2)}
var staticRenderFns = []

export { render, staticRenderFns }